import { themeUi } from '../../themeUi/themeUi';

export const sectionCard = {
  boxShadow: themeUi.core.shadow.shadow4
};
